import { productsListState } from './state';

export default (placeholder) => ({
  state: productsListState(placeholder),
  namespaced: true,
});
